import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

/**
 *  Yotpo Product Stars component
 *  loads the appropriate Star Ratings in Product Grid from Yotpo script based on sanityProduct.store.id
 */

export function YotpoStars({sanityProduct}) {
  const windowReady = typeof window !== 'undefined';
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (!windowReady) return;

    // Check if the script already exists
    const scriptExists = Array.from(
      document.head.getElementsByTagName('script'),
    ).some(
      (script) =>
        script.src ===
        'https://staticw2.yotpo.com/ExBZjowVYllRUQ4Dorgq6ev98MkYjY88bwXeEwlq/widget.js',
    );

    if (!scriptExists) {
      // Create a script element
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src =
        'https://staticw2.yotpo.com/ExBZjowVYllRUQ4Dorgq6ev98MkYjY88bwXeEwlq/widget.js';
      // Append the script to the <head> element
      document.head.appendChild(script);
    }

    setIsScriptLoaded(true);
  }, [windowReady, sanityProduct]);

  useEffect(() => {
    // Re-render the widget when the modal open state changes
    if (isScriptLoaded) {
      setTimeout(() => {
        // Perform your Yotpo widget initialization here
        if (typeof window.yotpo !== 'undefined') {
          window.yotpo.refreshWidgets();
        }
      }, 100); // NOTE: slight delay to allow yotpo init - 0ms may work; using 100 for now
    }
  }, [isScriptLoaded]);

  return isScriptLoaded && windowReady && sanityProduct ? (
    <div
      className="yotpo bottomLine"
      data-yotpo-product-id={sanityProduct.id}
      data-yotpo-url={window.location.href}
    ></div>
  ) : null;
}

YotpoStars.propTypes = {
  sanityProduct: PropTypes.object.isRequired,
};
